__webpack_require__.p = "/commonspirit/";